import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import RecordPagination from '../../utils/RecordsPagination';

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    negativeColor: {
        color: "red"
    },
    positiveColor: {
        color: "green"
    }
};

const CustomTableCell = withStyles(theme => ({
    head: {
        color: " #66bb6a",
        fontSize: "14px",
        fontWeight: "lighter"
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

const SettlementsTableStructure = ({ classes, settlementsData }) => (

    <div
        className={classes.tableResponsive}
        style={{ overflowX: "auto" }}
    >
        <Table className={classes.table} aria-labelledby="tableTitle">
            <TableHead color="success">
                <TableRow>
                    <CustomTableCell >
                        Flight<br />Date
          </CustomTableCell>
                    <CustomTableCell >
                        Airline<br />Name
          </CustomTableCell>
                    <CustomTableCell >
                        Flight<br />No
          </CustomTableCell>
                    <CustomTableCell >
                        Total<br />Passengers
          </CustomTableCell>
                    <CustomTableCell >
                        Billable<br />Passengers
          </CustomTableCell>
                    <CustomTableCell >
                        Outstanding<br />Billable<br />Passengers
          </CustomTableCell>
                    <CustomTableCell >
                        Settlement<br />Date
          </CustomTableCell>
                    <CustomTableCell >
                        PSC<br />Payment
          </CustomTableCell>
                    {/* <CustomTableCell >
                        Wallet<br />Balance
          </CustomTableCell> */}
                    <CustomTableCell >Status</CustomTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {settlementsData.map((n, i) => {
                    return (
                        <TableRow
                            hover
                            // onClick={event => this.handleClick(event, n.id)}
                            // tabIndex={-1}
                            key={i}
                        >
                            <CustomTableCell component="th" >
                                {appHelpers.formatDate(n.FlightDate, "MMM DD, YYYY")}
                            </CustomTableCell>
                            <CustomTableCell component="th" >
                                {n.Airline}
                            </CustomTableCell>
                            <CustomTableCell component="th" >
                                {n.FlightNo}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.TotalPassengers}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.BillablePassengers}
                            </CustomTableCell>
                            <CustomTableCell >
                                {n.OutstandingBillablePassengers}
                            </CustomTableCell>
                            <CustomTableCell >
                                {(n.SettlementDate) ? appHelpers.formatDate(n.SettlementDate) : ""}
                            </CustomTableCell>
                            <CustomTableCell >
                                &#8358; {appHelpers.numberWithCommas(n.PSCAmount)}
                            </CustomTableCell>
                            {/* <CustomTableCell >
                                &#8358; {appHelpers.numberWithCommasOnly(n.WalletBalance)}
                            </CustomTableCell> */}
                            <CustomTableCell >
                                {n.Status === "Successful" ? (
                                    <span className={classes.positiveColor}>
                                        {n.Status}
                                    </span>
                                ) : (
                                        <span className={classes.negativeColor}>
                                            {n.Status}
                                        </span>
                                    )}
                            </CustomTableCell>
                        </TableRow>
                    );
                })}
                {/* {emptyRows > 0 && (
                    <TableRow style={{ height: 48 * emptyRows }}>
                        <CustomTableCell colSpan={6} />
                    </TableRow>
                )} */}
            </TableBody>
            {/* <TableFooter>
                <TableRow>
                    <TablePagination
                        colSpan={3}
                        count={data.Results.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        className={classes.pagination}
                    // ActionsComponent={TablePaginationActionsWrapped}
                    />
                </TableRow>
            </TableFooter> */}
        </Table>
    </div>
)

class SettlementsTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    render() {
        const { classes, settlementsData, fetchSettlements, totalSettlementCount, pageSize, currentPage } = this.props
        return (
            <div>
                <RecordPagination
                    fetchMore={fetchSettlements}
                    totalCount={totalSettlementCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    target={<SettlementsTableStructure
                        classes={classes}
                        settlementsData={settlementsData} />} />
            </div>
        )
    }
}

export default withStyles(styles)(SettlementsTable);



// WEBPACK FOOTER //
// ./src/views/Settlement/SettlementsTable.jsx